import React from "react";
import { Descriptions, Typography } from "antd";
import { Control } from "../../../flatbuffers/generated/control/control";

interface CommandSentNotificationDetailsProps {
  serverName?: string;
  serverId?: string;
  command?: unknown;
  position?: unknown;
  active?: boolean;
  bankId?: string;
  liftId?: string;
  channelId?: string;
}

const getControlLabel = (commandValue: unknown): string => {
  if (typeof commandValue !== "number") return "--";
  return Control[commandValue] ?? `Unknown(${commandValue})`;
};

function CommandSentNotificationDetails({
  serverName = "",
  serverId = "",
  command = "--",
  position = "--",
  active = false,
  bankId = "",
  liftId = "",
  channelId = "",
}: CommandSentNotificationDetailsProps) {
  const commandLabel = getControlLabel(command);

  return (
    <Descriptions column={1} size="small" bordered>
      <Descriptions.Item label="Server">
        <span style={{ fontWeight: 600 }}>{serverName || serverId || "--"}</span>
      </Descriptions.Item>
      <Descriptions.Item label="Command">
        <span style={{ fontWeight: 600 }}>
          {typeof command === "number" ? `${command} (${commandLabel})` : String(command ?? "--")}
        </span>
      </Descriptions.Item>
      <Descriptions.Item label="Position">{String(position ?? "--")}</Descriptions.Item>
      <Descriptions.Item label="Active">{active ? "Yes" : "No"}</Descriptions.Item>
      <Descriptions.Item label="Bank ID">
        <Typography.Text
          code
          copyable={!!bankId && { text: bankId }}
          style={{ whiteSpace: "nowrap", display: "inline-block", maxWidth: "100%" }}
          ellipsis={{ tooltip: bankId || "--" }}
        >
          {bankId || "--"}
        </Typography.Text>
      </Descriptions.Item>
      <Descriptions.Item label="Lift ID">
        <Typography.Text
          code
          copyable={!!liftId && { text: liftId }}
          style={{ whiteSpace: "nowrap", display: "inline-block", maxWidth: "100%" }}
          ellipsis={{ tooltip: liftId || "--" }}
        >
          {liftId || "--"}
        </Typography.Text>
      </Descriptions.Item>
      <Descriptions.Item label="Channel ID">
        <Typography.Text
          code
          copyable={!!channelId && { text: channelId }}
          style={{ whiteSpace: "nowrap", display: "inline-block", maxWidth: "100%" }}
          ellipsis={{ tooltip: channelId || "--" }}
        >
          {channelId || "--"}
        </Typography.Text>
      </Descriptions.Item>
    </Descriptions>
  );
}

export default CommandSentNotificationDetails;
